'use client';
import { CompassContextProvider } from '@/src/libs/CompassContext';
import Compass from '@/src/components/Compass/Compass';

const CompassApp = () => {
  return (
    <CompassContextProvider>
      <Compass />
    </CompassContextProvider>
  );
};

export default CompassApp;
